export const formatPhoneNumber = (phone) => {
    if (!phone) return '';

    // Remove everything except digits
    const digits = phone.replace(/\D/g, '');

    // Strip country code if it's +1
    const raw = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

    if (raw.length !== 10) return phone; // fallback if not 10 digits

    return `(${raw.slice(0, 3)}) ${raw.slice(3, 6)}-${raw.slice(6)}`;
};